import { useLDClient } from "launchdarkly-react-client-sdk";
import { FeatureFlag } from "feature_flags/feature-flags";

export const useIsFlagEnabled = (flag: FeatureFlag) => {
  const ldClient = useLDClient();

  return ldClient?.variation(flag) === true;
};
